export default __webpack_public_path__ + "static/media/bg.45375d53.png";